import React from 'react';
import { Types } from '@wheeebo/polaris-api';
import RotationForm from './RotationForm';
function RotateGimbalRelativeForm({ onSubmit }) {
    return (React.createElement(RotationForm, { message: "Specify the rotation relative to the current rotation of the gimbal.", onSubmit: (props) => onSubmit(Types.VehicleCommandRotateGimbalRelative, props) }));
}
export default React.memo(RotateGimbalRelativeForm);
